import { render, staticRenderFns } from "./HMSPage.vue?vue&type=template&id=7bec2196&scoped=true&"
import script from "./HMSPage.vue?vue&type=script&lang=js&"
export * from "./HMSPage.vue?vue&type=script&lang=js&"
import style0 from "./HMSPage.vue?vue&type=style&index=0&id=7bec2196&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7bec2196",
  null
  
)

export default component.exports